import z from 'zod'

export const tabItems = ['province', 'city', 'bpp', 'posluhdes'] as const

/** Tabs yang ditampilkan di UI; Provinsi & Kabupaten/ Kota disembunyikan */
export const visibleTabItems = ['bpp', 'posluhdes'] as const

export const searchParamsSchema = z.object({
  tab: z
    .string()
    .optional()
    .default('bpp')
    .transform(val => {
      if (val === 'province' || val === 'city') return 'bpp'
      return val as (typeof tabItems)[number]
    }),
  province_code: z.string().optional(),
  city_code: z.string().optional(),
  district_code: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  per_page: z.coerce.number().optional().default(50)
})

export type SearchParams = z.infer<typeof searchParamsSchema>

export type TabItem = (typeof tabItems)[number]
